module.exports = __webpack_public_path__ + "static/media/bnb.948fe475.JPG";